import React from "react";
import Products from "./products/Products";
import Navbar from "./Navbar/Navbar";
import Cart from "./Cart/Cart";
import Checkout from "./CheckoutForm/Checkout/Checkout";
import { Routes, Route } from "react-router-dom";
import { useCartContext } from "@/hooks/useCartContext";
import { CircularProgress } from "@mui/material";
var AppRoutes = function () {
    var _a = useCartContext(), cart = _a.cart, order = _a.order, errorMessage = _a.errorMessage, handleCaptureCheckout = _a.handleCaptureCheckout, handleUpdateCartQty = _a.handleUpdateCartQty, handleRemoveFromCart = _a.handleRemoveFromCart, handleEmptyCart = _a.handleEmptyCart;
    return (React.createElement(React.Fragment, null,
        React.createElement(Navbar, { totalItems: cart === null || cart === void 0 ? void 0 : cart.total_items }),
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/", element: React.createElement(Products, null) }),
            React.createElement(Route, { path: "/cart", element: cart ? (React.createElement(Cart, { cart: cart, handleUpdateCartQty: handleUpdateCartQty, handleRemoveFromCart: handleRemoveFromCart, handleEmptyCart: handleEmptyCart })) : (React.createElement(CircularProgress, null)) }),
            React.createElement(Route, { path: "/checkout", element: cart ? (React.createElement(Checkout, { cart: cart, order: order, onCaptureCheckout: handleCaptureCheckout, error: errorMessage, handleEmptyCart: handleEmptyCart })) : (React.createElement(CircularProgress, null)) }))));
};
export default AppRoutes;
